import { Grid } from "@mui/material";
import ListaBebidas from "./Componentes/SubComponentes/ListaBebidas";
import { Helmet } from "react-helmet";

const Seccion_Bebidas = () => {
    return (
        <>
            <Helmet>
                <title>Bebidas | Toppings</title>
                <meta
                    name="description"
                    content="Disfruta de las mejores bebidas en Colón. Refrescos, jugos y malteadas con los toppings más deliciosos en Toppings."
                />
                <meta
                    name="keywords"
                    content="bebidas en Colón, refrescos en Colón, jugos en Colón, malteadas en Colón, bebidas frías Colón, mejores bebidas Colón, bebidas cerca de mí, bebidas para llevar Colón"
                />
                <meta name="robots" content="index, follow" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Restaurant",
                        name: "Toppings",
                        image: "https://toppings-colon.web.app/toppings.png",
                        url: "https://toppings-colon.web.app/",
                        telephone: "+57 3132391633",
                        address: {
                            "@type": "PostalAddress",
                            addressLocality: "Colón",
                            addressRegion: "Nariño",
                            addressCountry: "CO"
                        },
                        servesCuisine: ["Comida rápida", "Helados", "Bebidas"],
                        priceRange: "$"
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <ListaBebidas />
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Bebidas;
